'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import { handleChange } from '@/Form/Functions/eventsHandling'

import getFormStatus from '@/Form/Functions/getFormStatus'

import FormElement from '@/Form/toolkit/FormElement'

import Cart      from '@/Cart'
import CartTotal from '@/CartTotal'

import request from '@function/ajax/request'

import Loader from '@Pure/Loader'

import { isTrue } from '@root/utility'

const { app, qwest, moment } = window;

export default class CartPage extends Component
{
	state =
	{
		cart: [],

		can_pay: true,

		cart_fetched: false,

		verifying: false,

		open_hours_ok: isTrue(
			window.sessionStorage.getItem('open_hours_acknowledgement')
		),

		form_data: { }
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.state.order_process.user_abondement = '0';

		app.push(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.setState(
		{
			cart: app.state.cart
		});

		component.handleSessionChange();

		component.fetchCart();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'cartChange',
			cb: component.handleCartChange
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		handleChange.bind(component)(e, data);

		Object.keys(app.state.order_process).forEach(function (property)
		{
			if (property.indexOf('errors') === 0)
			{
				delete app.state.order_process[property];
			}
		});

		qwest.post('/order-process/update', { order_process: app.state.order_process })
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	handleAcknowledgement = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		window.sessionStorage
		.setItem('open_hours_acknowledgement', isTrue(data?.value));

		component.setState(
		{
			open_hours_ok: isTrue(data?.value),

			error: undefined
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session.id) return;

		component.setState(
		{
			can_pay:
			[
				isTrue(app.state.session.permissions.pay),
				isTrue(app.state.session.permissions.can_pay)
			]
			.some(condition => condition === true),

			form_data: state.form_data
		});
	}

	fetchCart = () =>
	{
		const component = this, props = this.props, state = this.state;

		qwest.post('/cart/get')
		.then(function (xhr, response)
		{
			app.state.cart = response.cart;

			app.state.cart_fetched = true;

			app.emit('cartChange', { label: 'initState' });
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	handleCartChange = () =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			cart_fetched: true,

			cart: app.state.cart || []
		});
	}

	requestOrderPage = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		const may_proceed = state.open_hours_ok || isInstantOrder();

		if (!may_proceed)
		{
			return component.setState(
			{
				error: 'Vous devez cochez la case d\'information sur ' +
					'les heures d\'ouverture'
			});
		}

		(async function ()
		{
			component.setState({ verifying: true });

			try
			{
				await request('/cart/update')
				.config({ keyword: 'action' })
				.post({ cart: app.state.cart });
			}
			catch (update)
			{
				component.setState(update);
				component.fetchCart();

				return;
			}
			finally
			{
				component.setState({ verifying: false });
			}

			return props.history.push('/panier/commander');
		})();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const instant_cart = isInstantOrder();

		let cannot_pay_msg =
		(
			<Layout page_title="Panier" history={ props.history }>

				<div className="page-content">

					<div className="o-content">
						<div className="c-form-message c-form-message--red">
							<div className="c-form-message__content">
								Vous n'avez pas les droits requis.
							</div>
						</div>
					</div>

				</div>

			</Layout>
		);

		if (isTrue(component.state.can_pay) !== true)
		{
			return cannot_pay_msg;
		}

		const verifying_loader = state.verifying === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;

		let payment_btn =
		(
			<div className="u-full-width u-text-right u-margin-top-20">
				<button type="button" className="c-btn cart-checkout"
					onClick={ component.requestOrderPage }>
					<svg className="o-svg-icon o-svg-icon--shopping-cart">
						<use xlinkHref="/images/icons.svg#svg-icon-shopping-cart" />
					</svg>
					&nbsp;Commander
					{ verifying_loader}
				</button>
			</div>
		);

		if (component.state.cart.length === 0)
		{
			payment_btn = undefined;
		}

		const today = moment();

		const closed =
		[
			today.format('YYYY-MM-DD') === '2023-12-26' && today.get('hour') > 12,
			today.isAfter('2023-12-29', 'day') && today.isBefore('2024-01-01', 'day')
		]
		.some(condition => condition);

		const page_content = closed ?
		(
			<div className="o-content">

				<div className="c-title u-no-margin-top">
					<h2 className="c-title__txt">
						Mon panier
					</h2>
				</div>

				<div className="c-message c-message--red">

					<div className="c-message__content">
						Les commandes sont temporairement désactivées pour cause d'inventaire. Elles seront de nouveau disponibles à partir du 1er janvier 2024.
					</div>

				</div>

			</div>
		)
		: state.cart_fetched ?
		(
			<div className="o-content">

				<div className="c-title u-no-margin-top">
					<h2 className="c-title__txt">
						Mon panier
					</h2>
				</div>

				<Cart />

				<div className="u-text-right">
					<CartTotal source="cart-page" />
				</div>

				{
					app.state.session
					?.permissions?.title === 'Administrateur de CE' ?
					(
						<div className="c-message c-message--blue">

							<div className="c-message__content">
								Vous vous apprêtez à faire une commande en tant que membre et pas en tant qu'administrateur de votre structure. Si vous souhaitez faire une commande au nom de votre structure, passez en mode administrateur avant de commander.
							</div>

						</div>
					)
					: undefined
				}

				{
					payment_btn && !instant_cart ?
					(
						<div className="u-full-width u-text-right u-margin-top-15">
							<FormElement type="checkbox" name="open_hours_ok"
								label="Les commandes sont traitées entre 8h30 et 17h30 du lundi au vendredi hors jours fériés"
								onChange={ component.handleAcknowledgement }
								data={ { open_hours_ok: state.open_hours_ok } }
								status={ state.status_messages }
								className="u-margin-top-0 u-positioned"
							/>
						</div>
					)
					: undefined
				}

				{ getFormStatus(state) }

				{ payment_btn }

			</div>
		)
		:
		(
			<div className="o-content standalone-loaner-container">
				<Loader className="c-loader"
					bemit={ ['white', 'bg-orange'] }
				/>
			</div>
		);

		var output =
		(
			<Layout page_title="Panier" history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					{ page_content }

				</div>

			</Layout>
		);

		return output;
	}
}

function isInstantOrder ()
{
	return (app.state.cart || []).every(function (product)
	{
		if (!isTrue(product.cart_onlineTicket)) return false;

		return product.online_type === 'instant';
	});
}